import { mapActions, mapState } from "vuex";
import StatisticsLine from "../chart-types/statistics-line";
import i18n from "../../../plugins/i18n";
import { StatusTypes } from "../../../constants/status_types";

export default {
  name: "FertilityChart",
  components: { StatisticsLine },
  data: () => ({
    categories: {
      voluntary: { name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.VoluntaryWaitingPeriod}`) },
      repro: { name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.ReproPeriod}`) },
      inseminated: { name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.Inseminated}`) },
      pregnantAndDry: { name: i18n.t(`cowGenerics.cowLogs.${StatusTypes.Pregnant}`) }
    }
  }),
  computed: {
    ...mapState({
      chartData(state) {
        const fertilityData = {
          voluntary: state.states.totals[StatusTypes.VoluntaryWaitingPeriod],
          repro: state.states.totals[StatusTypes.ReproPeriod],
          inseminated: state.states.totals[StatusTypes.Inseminated],
          pregnantAndDry:
            state.states.totals[StatusTypes.Pregnant] +
            state.states.totals[StatusTypes.Dry]
        };

        // Sum the dataset, this will be the 100%
        const highestData = Math.max(
          ...Object.values(fertilityData)
        );

        // Format data
        const formattedData = Object.keys(this.categories).map(category => {
          return {
            data: fertilityData[category],
            key: category,
            name: this.categories[category].name,
            // calculate percentage
            percentage:
              highestData > 0 ? (fertilityData[category] / highestData) * 100 : 0
          };
        });
        return formattedData;
      },
      isFetching: state => state.chart.isFetching
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/_charts/fertility/fertility-chart.js